import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

type CalendarEventsConfigurationStoreType = {
  configuredCalendarEvent: SchedulerV3.Types.CalendarEventType | null;
  setConfiguredCalendarEvent: (value: SchedulerV3.Types.CalendarEventType | null) => void;
};

const useCalendarEventsConfigurationStore = createStoreWithSubscribe<CalendarEventsConfigurationStoreType>(
  (set) => ({
    configuredCalendarEvent: null,
    setConfiguredCalendarEvent: (value) => set({ configuredCalendarEvent: value }),
  }),
  { name: 'calendarEventsConfigurationStore' }
);

export const useCalendarEventsConfigurationShallowStore = createShallowStore(useCalendarEventsConfigurationStore);
